import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
  DATA_CHECK_GET_FAILURE: "DATA_CHECK_GET_FAILURE",
  DATA_CHECK_GET_REQUEST: "DATA_CHECK_GET_REQUEST",
  DATA_CHECK_GET_SUCCESS: "DATA_CHECK_GET_SUCCESS",

  DATA_CHECK_CLEAR: "DATA_CHECK_CLEAR",
  DATA_CHECK_MERGE: "DATA_CHECK_MERGE",

  DATA_CHECK_POST_REQUEST: "DATA_CHECK_POST_REQUEST",
  DATA_CHECK_POST_FAILURE: "DATA_CHECK_POST_FAILURE",
  DATA_CHECK_POST_SUCCESS: "DATA_CHECK_POST_SUCCESS"
};

export const actionCreators = {
  getRequest: () => ({
    type: actionTypes.DATA_CHECK_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.DATA_CHECK_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.DATA_CHECK_GET_FAILURE
  }),
  getSuccess: (dataCheck: Array<any>) => ({
    type: actionTypes.DATA_CHECK_GET_SUCCESS,
    payload: { dataCheck }
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.DATA_CHECK_GET_FAILURE,
    error
  }),
  clear: () => ({
    type: actionTypes.DATA_CHECK_CLEAR
  }),
  merge: (dataCheck: Array<any>) => ({
    type: actionTypes.DATA_CHECK_MERGE,
    payload: { dataCheck }
  }),

  postRequest: (dataCheck: any) => ({
    type: actionTypes.DATA_CHECK_POST_REQUEST,
    payload: { dataCheck },
    [WAIT_FOR_ACTION]: actionTypes.DATA_CHECK_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.DATA_CHECK_POST_FAILURE
  }),
  postSuccess: (dataCheck: any) => ({
    type: actionTypes.DATA_CHECK_POST_SUCCESS,
    payload: { dataCheck }
  }),
  postFailure: error => ({
    type: actionTypes.DATA_CHECK_POST_FAILURE,
    error
  })
};

export default {
  create: actionCreators,
  type: actionTypes
};
